import { DeliveredAmountsOverview } from './DeliveredAmountsOverview';
import { CompletedAmountsOverview } from './CompletedAmountsOverview';
import { Transaction } from '../../../../models';

type TransactionAmountsOverviewProps = {
  transaction: Transaction;
};

export const TransactionAmountsOverview = ({
  transaction,
}: TransactionAmountsOverviewProps) => {
  return (
    <div data-testid={'transactions-sidebar-amounts'}>
      <DeliveredAmountsOverview transaction={transaction} />
      <CompletedAmountsOverview transaction={transaction} />
    </div>
  );
};
